import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { formatEstimatedDelivery } from "src/components/Paradise/ParadiseShipping/paradiseShippingUtils"
import { TAvailableShippingMethod } from "src/data/ecommerce/ecommerceTypes"
import { Divider } from "src/ui/Divider/Divider"
import { MCard } from "src/ui/MCard/MCard"
import { spacing } from "src/ui/spacing"

export function ParadiseShippingMethodCard({
  shippingMethod,
}: {
  shippingMethod: TAvailableShippingMethod
}) {
  return (
    <MCard boxShadow={false} border>
      <Row>
        <div>
          <Text variant="subtitle">{shippingMethod.name}</Text>
          <Text variant="bodyXS">{shippingMethod.shipping_method_id}</Text>
        </div>
        <div>
          <Text variant="subtitleS">
            {shippingMethod.price.formatted_amount}
          </Text>
        </div>
      </Row>

      <Divider $margin={spacing.S} />

      <ShipmentsWrapper>
        {shippingMethod.shipments?.map((shipment, index) => (
          <div key={index}>
            <Text variant="subtitleS">
              Shipment {index + 1} (
              {formatEstimatedDelivery({
                min: shipment.estimated_delivery.min,
                max: shipment.estimated_delivery.max,
                unit: shipment.estimated_delivery.unit,
              })}
              )
            </Text>
            {shipment.product_ids.map((id) => (
              <div key={id}>
                <Text variant="bodyXS">{id}</Text>
              </div>
            ))}
          </div>
        ))}
      </ShipmentsWrapper>
    </MCard>
  )
}

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ShipmentsWrapper = styled.div`
  display: grid;
  gap: ${spacing.S};
`
